module.exports = __webpack_public_path__ + "img/20230329204514658xdd.c8a17593.jpg";